import React from 'react';
import MissionProfile from './MissionProfile';
import RocketProfile from './RocketProfile';

const MyProfile = () => (

  <main className="profile-main">
    <MissionProfile />
    <RocketProfile />
  </main>
);

export default MyProfile;
